import React from 'react';
import MainLayout from '../Layout/NewLayout';
import DestinationForm from '../Pages/Destination/DestinationForm';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CompactMerchantManagementPage from '../Pages/Merchant/MerchantList';
import NavigationTabs from '../Pages/Merchant/Merchantform';
import MerchantInformation from '../../Component/Merchant/MerchantInformation';
import Document from '../../Component/Merchant/Document';
import MerchantForm from '../../Component/Merchant/BasicInfo';
import LoginPage from '../../../Components/Login';
import Dashboard from '../../../Components/Dashboard/Dashboard';
import EntityRegistration from '../../../Components/Entity/Registration/page'
import CancellationTable from '../../../Components/Dashboard/Cancellation/CancellationTable';
import EntityView from '../../../Components/Entity/EntityView';
import DestinationList from "../Pages/Destination/DestinationList";
import ReferencesList from '../../../Components/References/References';
import OrderDetails from '../Pages/Order/OderDetails';
import OrderListing from '../Pages/Order/OderList';
import TicketManagement from '../Pages/Ticket/TicketList';
import TicketTabs from '../Pages/Ticket/TicketTabs';
import UserManagementInterface from '../../Component/User/UserManage';
import Sidebar from '../../Component/LayoutComponent/Sidebar2';
import UserCreationForm from '../Pages/User/UserCreationForm';
import VendorUserAccountForm from '../../Component/User/VendorUser';
import BankAccountManagement from '../../Component/Merchant/BankAccountManagement';
import CMSDashboard from '../Pages/CMS/CMSDashboard';
import Settings from '../../Component/Meta/Configdashboard';
import Banner from '../Pages/CMS/banner';
import MultiSelectDropdown from '../../Component/Dropdown/TicketOrigin';
import TourGuidesManagement from '../Pages/Tourguide/TourGuide';
import TourGuideRegistration from '../Pages/Tourguide/GuideRegister';
import EditNavigationTabs from '../Pages/Merchant/Editmerchantform';
import Attraction from '../Pages/CMS/Attraction';
import CustomPageAttractions from '../Pages/CMS/CustomPageAttractions';
import CustomPageBannerGroups from '../Pages/CMS/CustomPageBannerGroups';
import MerchantDashboard from '../Pages/MerchantDashboard/MerchantDashboard';
import List from '../Pages/CMS/List';
import OrderDetailsComponent from '../Pages/MerchantDashboard/OrderViewMerchant';
import SriLankaBookingComponent from '../Pages/CMS/Heropopup';
import ProvincialAdminDashboard from '../Pages/ProvincialCouncilDashboard/CouncilDashboard';
import CustomPageList from '../Pages/CMS/BlockList';
import ViewMore from '../Pages/CMS/view_more';
import CustomPageBlocks from '../Pages/CMS/custompage';
import LandingPage from '../Pages/CMS/Landingpage';
import AttractionView from '../Pages/CMS/AttractionView';
import AttractionEdit from '../Pages/CMS/AttractionEdit';
import BannerGroups from '../Pages/CMS/BannerGroups';
import MerchantView from '../Pages/Merchant/MerchantView';
import ViewBannerGroup from '../Pages/CMS/ViewBannerGroup';
import EditBannerGroup from '../Pages/CMS/EditBannerGroup';
import Profile from '../Pages/Profile/Profile';


function App() {
  const authState = useSelector(state => state.auth);

  if (!authState.isAuthenticated) {
    return (
      <Router>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    );
  }
  return (


    <Router>
      <Routes>
        <Route path="/Sidebar" element={< Sidebar />} />

        <Route path="/" element={<MainLayout />}>
          <Route path="/DestinationForm" element={<DestinationForm />} />
          <Route path="/MerchantBasicInfo" element={<MerchantForm />} />
          <Route path="/" element={<Dashboard />} />
          <Route path="/DestinationList" element={<DestinationList />} />
          <Route path="/EntityRegistration" element={<  EntityRegistration />} />
          <Route path="/ReferencesList" element={<  ReferencesList />} />
          
          <Route path="/CancellationTable" element={<  CancellationTable />} />
          <Route path="/EntityView" element={<  EntityView />} />
          <Route path="/CompactMerchantManagementPage" element={< CompactMerchantManagementPage />} />
          <Route path="/MerchantForm" element={<  NavigationTabs />} />
          <Route path="/MerchantInformation" element={<  MerchantInformation />} />
          <Route path="/MerchantDocument" element={< Document />} />
          <Route path="/OrderDetails" element={< OrderDetails />} />
          <Route path="/OrderListing" element={< OrderListing />} />
          <Route path="/TicketManagement" element={< TicketManagement />} />
          <Route path="/TicketTabs" element={< TicketTabs />} />
          <Route path="/UserManagementInterface" element={< UserManagementInterface />} />
          <Route path="/UserCreationForm" element={< UserCreationForm />} />
          <Route path="/VendorUserAccountForm" element={< VendorUserAccountForm />} />
          <Route path="/BankAccountManagement" element={< BankAccountManagement />} />
          <Route path="/CMSDashboard" element={< CMSDashboard />} />
          <Route path="/Settings" element={< Settings />} />
          <Route path="/MultiSelectDropdown" element={< MultiSelectDropdown />} />
          <Route path="/TourGuidesManagement" element={<TourGuidesManagement  />} />
          <Route path="/TourGuideRegistration" element={<TourGuideRegistration />} />
          <Route path="/EditNavigationTabs" element={< EditNavigationTabs />} />
          <Route path="/Attraction" element={< Attraction />} />
          <Route path="/CustomPageAttractions" element={< CustomPageAttractions />} />
          <Route path="/CustomPageBannerGroups" element={< CustomPageBannerGroups />} />
          <Route path="/MerchantDashboard" element={< MerchantDashboard />} />
          <Route path="/CMSList" element={< List />} />
          <Route path="/OrderDetailsComponent" element={< OrderDetailsComponent />} />
          <Route path="/SriLankaBookingComponent" element={< SriLankaBookingComponent />} />
          <Route path= "/ProvincialAdminDashboard" element={<ProvincialAdminDashboard/>} />
          <Route path="/BlockList" element={< CustomPageList />} />
          <Route path="/ViewMore" element={< ViewMore />} />
          <Route path="/Banner" element={< Banner />} />
          <Route path="/CustomPageBlocks" element={< CustomPageBlocks />} />
          <Route path="/LandingPage" element={< LandingPage />} />
          <Route path="/AttractionView" element={< AttractionView />} />
          <Route path="/AttractionEdit" element={< AttractionEdit />} />
          <Route path="/BannerGroups" element={< BannerGroups />} />
          <Route path="/MerchantView" element={< MerchantView />} />
          <Route path="/ViewBannerGroup" element={< ViewBannerGroup />} />
          <Route path="/EditBannerGroup" element={< EditBannerGroup />} />
          <Route path="/Profile" element={< Profile />} />


        </Route>
        <Route path="/MainLayout" element={<  MainLayout />} />
      </Routes>
    </Router>

  );
}

export default App;
